<template>
	<div class="List">
		<div class="results">
			<div v-if="!noHeading" class="headings" >
				<div class="heading" v-for="(col,l) in columns" :key="'th_'+l" v-bind:style="{ width : col.width ? (col.width * 100) + '%' : ( col.status ? '1em' : null ),'flex-basis':col.basis||0 }"  >
					{{ col.label }}
				</div>
			</div>
			<template v-if="!intial_load_complete || loading" >
				<div v-for="n in 3" :key="'tr_'+n" >
					<div v-for="(col,m) in columns" :key="'col_'+m" :style="col.basis?{'flex-basis':col.basis}:{}"  >

						<template v-if="col.status" >
							<span :class="['StatusIndicator']"  ></span>
						</template>
						<template v-else >
							<div class="loading_string"></div>
						</template>

					</div>
				</div>
			</template>
			<div
				v-else-if="ordered_results.length"
				v-for="(result,i) in ordered_results"
				:key="result.id || 'item_'+i"
				:class="{clickable:columns.find(x=>x.rowClick)}"
				>
				<div v-for="(col,j) in columns" :key="'col_'+j" :class="(typeof col.class === 'function') ? col.class(result[col.name],result) : col.class" :style="col.basis?{'flex-basis':col.basis}:{}" >

					<template v-if="col.status" >
						<span :class="['StatusIndicator', (typeof col.status === 'function') ? col.status(result[col.name],result) : col.status ]"  ></span>
					</template>


					<UserIcon v-else-if="col.usericon" :user="result" />

					<router-link v-else-if="col.to" :to="col.to(result[col.name],result)" :ref="col.rowClick?'RC'+result.id:null" :class="{rowclick_link:!!col.rowClick}" >{{ col.text ? col.text(result[col.name],result) : result[col.name] }}</router-link>

					<template v-else-if="col.buttons && col.buttons(result)" >
						<button v-for="(button,k) in col.buttons(result)"  :key="'btn_'+k" :class="button.class" v-on:click.stop="button.action" >{{ button.text }}</button>
					</template>

					<template v-else>
						{{ col.text ? col.text(result[col.name],result) : result[col.name] }}
					</template>

				</div>
			</div>
			<div v-else>
				<div>
					<div class="empty">
						<slot>None found</slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import UserIcon from "../components/UserIcon.vue";

	export default {

		components : {
			UserIcon
		},

		props : [
			'loading',
			'columns',
			'results',
			'orderResults',
			'noHeading',
			],

		data() {
			return {
				intial_load_complete : typeof this.loading === "undefined", // If no loading param is past, initial load is complete
			};
		},

		watch : {
			loading : function(){
				if(!this.loading){
					this.intial_load_complete = true;
				}
			},
		},

		computed : {
			normalised_results : function(){
				return this.results.map( x =>{
					if(!x.id){
						x.id=Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
					};
					return x;
				});
			},
			ordered_results : function(){
				return this.orderResults ? this.orderResults(this.normalised_results) : this.normalised_results;
			},
		},

		methods: {

			rowClick(result,event){
				if(this.$refs['RC'+result.id] && this.$refs['RC'+result.id].length){
					var target = this.$refs['RC'+result.id][0].$el;
				} else {
					return;
				}

				if( !$(event.target).attr('href') ){
					target.dispatchEvent(new MouseEvent('click', {
						bubbles:true,
						cancelable: true,
						button: event.button,
						which: event.which,
						ctrlKey : event.ctrlKey
					}));
				}
			}

		},

	}

</script>